import { type } from "@testing-library/user-event/dist/type";

// src/data/discography.js
export const discography = [
  {
    id: 1,
    key: "la_independencia_del_mesias",
    year: 2025,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/la-independencia-del-mesias.jpg",
    links: {
      primary: "https://youtu.be/xopFg6YRjGo?si=L2UKqav9NGZwZr7v",
    },
  },
  {
    id: 2,
    key: "punto_final",
    year: 2025,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/album-punto-final.png",
    links: {
      // Link updated from Home.js
      primary: "https://youtu.be/mWZkZ3cW8Pg?si=CjYkNKl947kYACE-",
    },
  },
  {
    id: 3,
    key: "loco_de_amor",
    year: 2025,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/album-loco-de-amor.jpg",
    links: {
      // Link updated from Home.js
      primary: "https://youtu.be/tnlmlTfjyjo?si=PTXadBq9VjMNRPuo",
    },
  },
  {
    id: 4,
    key: "de_dia_y_noche",
    year: 2025,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/album-de-dia-y-de-noche.jpg",
    links: {
      // Link updated from Home.js
      primary: "https://youtu.be/IQTIxQSEu6s?si=TBDE3EN8ltZIxp4p",
    },
  },
  {
    id: 5,
    key: "ranchero_hasta_las_cachas",
    year: 2025,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/ranchero-hasta-las-cachas.jpg",
    links: {
      primary: "https://youtu.be/CjtpNad85cg?si=zVkVZcSRoaHSWUoB",
    },
  },
  {
    id: 6,
    key: "el_culpable_no_fui_yo",
    year: 2025,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/el-culpable-no-fui-yo.jpg",
    links: {
      primary: "https://youtu.be/tBNEXX511y8?si=I6ZH0GeHQefmV8iP",
    },
  },
  {
    id: 7,
    key: "pobre_enamorada",
    year: 2025,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/pobre-enamorada.jpg",
    links: {
      primary: "https://youtu.be/HEnGMkoa7_w?si=6Mlo5nZ8G8QJCwkK",
    },
  },
  {
    id: 8,
    key: "mano_amiga",
    year: 2024,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/mano-amiga.jpg",
    links: {
      primary: "https://youtu.be/IV_Z-Lw3zic?si=8NKf3U7n7qs8RD9c",
    },
  },
  {
    id: 9,
    key: "mi_niñez_y_de_mojado",
    year: 2024,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/mi-ninez-y-de-mojado.jpg",
    links: {
      primary: "https://youtu.be/3gk1b0bXGmY?si=Z4jv2e1YHk3f1m8J",
    },
  },
  {
    id: 10,
    key: "tú_vestidito_rojo",
    year: 2024,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/tu-vestidito-rojo.jpg",
    links: {
      primary: "https://youtu.be/nJXRIeMT-dI?si=LRZD8ov_Mt6ql6S7",
    },
  },
  {
    id: 11,
    key: "antes_que_te_vayas",
    year: 2024,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/antes-de-que-te-vayas.jpg",
    links: {
      primary: "https://youtu.be/6Vuyijrpnww?si=KA6s_VTH7Dfg_lgx",
    },
  },
  {
    id: 12,
    key: "mi_chiqui_baby",
    year: 2024,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/mi-chiqui-baby.jpg",
    links: {
      primary: "https://youtu.be/FCNLtffLHt0?si=i0YpPY7a-Y7jpYEP",
    },
  },
  {
    id: 13,
    key: "tu_sonrisa_natural",
    year: 2023,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/tu-sonrisa-al-natural.jpg",
    links: {
      primary: "https://youtu.be/8zbO9zOHF44?si=vLlbXi10htpjT3VJ",
    },
  },
  {
    id: 14,
    key: "el_amigo_y_yo",
    year: 2023,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/el-amigo-y-yo.jpg",
    links: {
      primary: "https://youtu.be/5L3IumI9izc?si=-dDj37kKzWOCR-rQ",
    },
  },
  {
    id: 15,
    key: "desde_niño_nayib_bukele",
    year: 2023,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/desde-nino-nayib-bukele.jpg",
    links: {
      primary: "https://youtu.be/Zv925bxZ0aA?si=eorh3AgOELu14xRB",
    },
  },
  {
    id: 16,
    key: "el_collar_de_guamúchil",
    year: 2023,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/el-collar-de-guamuchil.jpg",
    links: {
      primary: "https://youtu.be/cZYhKdVcsNQ?si=XFPdXEowKbwcfvOd",
    },
  },
  {
    id: 17,
    key: "cada_febrero",
    year: 2023,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/cada-febrero.jpg",
    links: {
      primary: "https://youtu.be/GClhrLmtduo?si=jpS2m5NWTpIRIr3d",
    },
  },
  {
    id: 18,
    key: "ya_no_pasa_nada",
    year: 2023,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/ya-no-pasa-nada.jpg",
    links: {
      primary: "https://youtu.be/tqGb-1I3NT4?si=YsQLN9TFS425oWVI",
    },
  },
  {
    id: 19,
    key: "yo_seria_feliz",
    year: 2022,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/yo-seria-feliz.jpg",
    links: {
      primary: "https://youtu.be/iCvb6zBNJBU?si=44MHopKcprOj1ZvS",
    },
  },
  {
    id: 20,
    key: "que_tristeza_me_dio",
    year: 2022,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/que-tristeza-me-dio.jpg",
    links: {
      primary: "https://youtu.be/eGpZqV_VxH0?si=0VWk4bJ4hmINVtLo",
    },
  },
  {
    id: 21,
    key: "la_peineta",
    year: 2022,
    typeKey: "releaseTypeSingle",
    imageUrl: "/assets/images/la-peineta.jpg",
    links: {
      primary: "https://youtu.be/wryOH2Qzb54?si=IUkyUfZ4h6IRQ0Dd",
    },
  },
];
